"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("../../auth");
const exceptions_1 = require("../exceptions");
/**
 * Esegue la richiesta solo se il token esiste
 * (non controlla la validità lato server).
 *
 * @export
 * @class TokenExists
 * @throws TokenNotProvided
 */
class TokenExists {
    constructor(data) {
        if (auth_1.Auth.hasToken()) {
            return Promise.resolve(data);
        }
        throw new exceptions_1.TokenNotProvided();
    }
}
exports.default = TokenExists;
